<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-users"></i> {{ "TITLE.PERSON" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-alert-add-document [message]="alertMessage"></app-alert-add-document>
    <form autocomplete="off" [formGroup]="personForm">
      <div class="row">
        <div class="col-md-6" *ngIf="hasRole(ROLE_SUPERADMIN)">
          <label for="partnerSelect">{{ "LABEL.PARTNER" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
            </div>
            <select id="partnerSelect" class="form-control"
                    [(ngModel)]="something.partnerId"
                    (change)="reloadEnterprises()"
                    formControlName="partner">
              <option *ngFor="let partner of partners" [ngValue]="partner.id">{{partner.name | translate}}</option>
            </select>
          </div>
        </div>
        <div class="col" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
          <label for="enterpriseSelect">{{ "TITLE.ENTERPRISE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
            </div>
            <select id="enterpriseSelect"
                    class="form-control"
                    [(ngModel)]="something.enterpriseId"
                    formControlName="enterprise">
              <option *ngFor="let enterprise of enterprises"
                      [ngValue]="enterprise.id">{{enterprise.name | translate}}</option>
            </select>
            <small *ngIf="isInvalidControl('enterprise')"
                   class="text-danger">
              {{ "MESSAGE.SELECTED-COMPANY-IS-NOT-ASSOCIATED" | translate }}
            </small>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label for="customRubricFile2"
                 class="col-form-label">{{ "LABEL.FILE-WITH-PERSON-RECORDS" | translate }}</label>
          <div class="custom-file content-file">
            <input type="file"
                   class="custom-file-input"
                   accept=".xls, .xlsx"
                   id="customRubricFile2"
                   (change)="changeStatus($event)"
                   [class.is-invalid]="isInvalidControl('sourceDataExcelFile')">
            <small *ngIf="isInvalidControl('sourceDataExcelFile')"
                   class="text-danger">
              {{ "MESSAGE.SELECT-FILE-CONTAINING-LIST-PERSONS" | translate }}
            </small>
            <div class="custom-file-label">
              <label for="customRubricFile2">
                {{personForm.get('sourceDataExcelFilename2Show').value ? personForm.get('sourceDataExcelFilename2Show').value : ("MESSAGE.SELECT" | translate)}}
              </label>
            </div>
          </div>
        </div>
        <div class="col">
          <label class="mt-2" for="hole">{{ "LABEL.PROGRESS" | translate }}</label>
          <div id="hole" class="progress mt-2">
            <div class="progress-bar progress-bar-striped bg-success"
                 role="progressbar"
                 [style.width.%]="progressUpload">
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success " (click)="openConfirmDialog()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger " (click)="cancel()">
      <i class="fa fa-times-circle" aria-hidden="true"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
